import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import FsETLExternalView from './fs-etl-external-view'
import FsETLInternalView from './fs-etl-internal-view'
import { setLatestEtlStatus } from '../../store/actions'

const FsETLView = () => {
  const { account, token } = useAppSelector((state) => state.currentUser)
  const isInternalUser = account && account.isActive && account.isSuperuser
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (token) {
      dispatch(setLatestEtlStatus())
    }
  }, [token])

  return !isInternalUser ? <FsETLInternalView /> : <FsETLExternalView />
}

export default FsETLView
